import React from 'react';
import { Table } from 'react-bootstrap';
import Row from './components/Row';

const AdkBoostersTable = ({ boosters, onRemove, onUpdate }) => {
    const rows = boosters.map((booster, index) => <Row key={index} booster={booster} onUpdate={onUpdate} onRemove={onRemove}/>);

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th>Updated</th>
                    <th>Feed</th>
                    <th>Subid</th>
                    <th>Countries</th>
                    <th>Factor</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default AdkBoostersTable;


// WEBPACK FOOTER //
// ./src/scenes/AdkBoosters/components/Table/index.js